import '../App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle';
import Hero from '../hero/hero';
import Home from '../body/Home';
import BreadCrumb from '../utility/breadCrumb';

function Index() {
  return (
    <>
    <BreadCrumb linkto="" linkname="Home" linklevel="0" ></BreadCrumb>
      <Hero 
        paddingTop = "0"
        id="0" 
        contentId = "0"
        height="" 
        gradient="true" 
        gradientDirection="to right" 
        gradientRgba="rgba(0,0,0,1) 50%, transparent" 
        backgroundSize="auto 100%" 
        backgroundRepeat="no-repeat" 
        backgroundColor="#000" 
        backgroundPosition="right"
        maxWidth="1400px"
        margin="auto" >
      </Hero>
      <Home></Home>
    </>
  );
}

export default Index;
 